<template>
  <div class="table-footer">
    <TableSettings
      :config="config"
      @update-column="(params) => $emit('update-column', params)"
      @reset-settings="$emit('reset-settings')"
    />
    <TablePagination
      :current-page="currentPage"
      :pages="pages"
      @change-page="(val) => $emit('change-page', val)"
    />
  </div>
</template>

<script>
/**
 * Футер таблицы
 * @module Shared/Component/Table/TableFooter
 * @requires Shared/Table/Settings
 * @requires Shared/Table/Pagination
 * @vue-prop {Array} config - конфиг таблицы
 * @vue-prop {Number} currentPage - текущая открытая страница
 * @vue-prop {Number} pages - максимальное количество страниц
 * */

import TableSettings from 'Shared/Table/Settings'
import TablePagination from 'Shared/Table/Pagination'

export default {
  name: 'TableFooter',
  components: {
    TableSettings,
    TablePagination
  },
  props: {
    config: {
      type: Array,
      default: () => []
    },
    currentPage: {
      type: Number,
      default: 1
    },
    pages: {
      type: Number,
      default: 0
    }
  }
}
</script>

<style lang="scss" scoped>
.table-footer {
  padding: 5px 10px;
  display: flex;
  justify-content: space-between;
  margin-top: 1px;
  box-shadow: 0px 0px 0px 1px $table-border-color;
  border-radius: 0 0 10px 10px;
  background-color: $table-footer-background-color;
}
</style>
